import { t } from 'i18next';
import { RedirectPage } from '../../../components/redirect-page';
import { withPageProviders } from '../../../context/page-context';

export const CustomerGroupsRedirectPage = withPageProviders(CustomerGroupsRedirectContent);

function CustomerGroupsRedirectContent() {
  return (
    <RedirectPage
      path="/customers/groups"
      title={t('features:customer_group.pages.customer_groups_redirect_page.title')}
      subtitle={t('features:customer_group.pages.customer_groups_redirect_page.description')}
      action={t('features:customer_group.pages.customer_groups_redirect_page.action')}
      imageType="customerGroup"
    />
  );
}
